import { render, staticRenderFns } from "./createCustomer.vue?vue&type=template&id=309e8ff5&"
import script from "./createCustomer.vue?vue&type=script&lang=ts&"
export * from "./createCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports